// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
export const AuxiliaryItemContainer = styled.div `
  --icon-menu-size: 18px;

  .menu_item_title {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 0px 24px;
    height: 40px;
    overflow: hidden;
    cursor: pointer;
    position: relative;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: var(--color-opacity-hover);
    }

    &.menu_item_link {
      span {
        margin-left: 26px;
      }
    }

    span {
      font-size: var(--font-size-default);
    }

    .root-app_svg {
      svg {
        width: var(--icon-menu-size);
        height: var(--icon-menu-size);
        transition: transform 0.3s;
      }
    }
  }

  .menu_item_content {
    overflow: hidden;
    transition: opacity 0.3s ease-out;
    opacity: 0;
    height: 0;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &.open > .menu_item_content {
    height: auto;
    opacity: 1;
  }

  &.open > .menu_item_title {
    svg {
      transform: rotate(90deg);
    }
  }

  &.selected > .menu_item_title {
    font-weight: var(--font-weight-semibold);
    &:before {
      content: '';
      position: absolute;
      left: 0px;
      top: 0px;
      height: 40px;
      width: 8px;
      background-color: var(--color-brand-300);
    }
  }
`;
//# sourceMappingURL=style.js.map